import React from "react"
import { AppFunctionComponent } from "../../types"
import { Audio } from "../../types"
import { AudioPlayer } from "../../ui"

export const AudioComponentResolver: AppFunctionComponent<Audio> = ({
  tracks,
}) => {
  return <AudioPlayer tracks={tracks} />
}
